import { formatScore, scoreBadgeClass } from "@/lib/format";

export function SustainabilityScoreBadge({ score, size = "md", testId }) {
  const cls = scoreBadgeClass(score);
  const sizeCls = size === "lg" ? "text-2xl px-5 py-2" : size === "sm" ? "text-xs px-2 py-0.5" : "text-sm px-3 py-1";
  return (
    <span
      className={`inline-flex items-center rounded-full font-semibold ${cls} ${sizeCls}`}
      data-testid={testId || "sustainability-score-badge"}
    >
      {formatScore(score)}
    </span>
  );
}
